import select from '@assets/audio/select_quizz.mp3';
import { Howl } from 'howler';
import { useState, useRef, useEffect } from 'react';
import ImageMapper from 'react-img-mapper';
import { styled } from 'styled-components';
import { getStatusGrid } from '~/pages/components/game/activities-forms/utils';
// import {
//   getStatusGrid,
//   parseStringToCoord,
// } from '~/pages/components/game/activities-forms/utils';
import { TActivity, TAnswer } from '~/utils/airtable/types/types';
import { renderFullPath } from '~/utils/common/utils';
//import { classic } from '~/themes';

type IProps = {
  currentActivity: TActivity;
  selectedAnswers: string[];
  onChangeSelectedAnswers: (answers: string[]) => void;
  $submitted?: boolean;
  correctAnswers: string[];
};

type TProps = IProps;

export function ClickImageObjectItem({
  currentActivity,
  onChangeSelectedAnswers,
  $submitted,
}: TProps) {
  const [selected, setSelected] = useState<string[]>([]);
  const [soundSelect, setSoundSelect] = useState<Howl | null>(null);
  const containerRef = useRef(null);

  if (!currentActivity.image) return null;

  useEffect(() => {
    setSoundSelect(
      new Howl({
        src: [select],
        volume: 0.4,
        html5: true,
      })
    );

    return () => {
      soundSelect?.stop();
      soundSelect?.unload();
    };
  }, []);

  function handleClickArea(coords: string) {
    soundSelect?.play();
    const copy = [...selected];
    if (selected.includes(coords)) {
      const i = selected.findIndex((s) => s === coords);
      copy.splice(i, 1);
    } else {
      copy.push(coords);
    }
    setSelected(copy);
    onChangeSelectedAnswers(copy);
  }

  function getPrefillColorByStatus(a: string) {
    if (!$submitted) {
      if (selected.includes(a)) {
        return '#08b5cc4D';
      } else {
        return 'transparent';
      }
    } else {
      const status = getStatusGrid(
        a,
        selected,
        currentActivity.answers
          ?.filter((el) => el.isCorrect)
          .map((ans) => ans.text) ?? []
      );
      if (status === 'good') return '#14b15c80';
      if (status === 'warning') return '#e18b4880';
      if (status === 'wrong') return '#dd484880';

      return 'transparent';
    }
  }

  function getStrokeColor(a: string) {
    if (selected.includes(a)) {
      return '#08b5cc4D';
    } else {
      return 'transparent';
    }
  }

  return (
    <Container ref={containerRef}>
      {currentActivity.answers && (
        <ImageMapper
          src={renderFullPath(currentActivity.image)}
          onClick={(e: any) => {
            handleClickArea(e.title);
          }}
          responsive={true}
          parentWidth={
            //@ts-expect-error : I know what I'm doing
            containerRef.current?.offsetWidth || 0
          }
          map={{
            name: 'click-img',
            areas: currentActivity.answers.map((a: TAnswer) => ({
              shape: 'circle',
              coords: a.text.split(',').map(Number),
              href: '#',
              title: a.text,
              preFillColor: getPrefillColorByStatus(a.text),
              strokeColor: getStrokeColor(a.text),
            })),
          }}
        />
      )}
    </Container>
  );
}
const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
`;
